import React, { useState, useEffect } from "react";
import httpService from "../../../services/http.service";
import "./settings.css";
import Loader from "../../common/loader";
import { useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import SettingNavbar from "./settingNav";
import ErrorMessage from "../../common/errorMsg";
import SuccessMessage from "../../common/successMsg";
import { BsEye, BsEyeSlash } from "react-icons/bs";

const SmtSettings = () => {
  const history = useHistory();
  let [service, setService] = useState("");
  let [usermail, setUserMail] = useState("");
  let [password, setPassword] = useState("");
  let [portnumber, setPortNumber] = useState("");
  let [sendername, setSenderName] = useState("");
  let [tomail, setToMail] = useState("");
  const [customerData, setCustomerData] = useState(null);
  const activeTab = "smtp"
  const [ticked, setTicked] = useState(false);
  const [encryptionMethod, setEncryptionMethod] = useState("none");
  const [showPassword, setShowPassword] = useState(false);
  let [loading, setLoading] = useState(false);
  const [changesMade, setChangesMade] = useState(false);

  useEffect(() => {
    getCustomerData();
  }, []);

  const getCustomerData = async () => {
    let res = await httpService.getByBoj("/getsmtpdetails")
      .then((res) => res.data)
      .catch((err) => { return });
    if (res && res.length > 0) {
      setCustomerData(res[0]);
      setSenderName(res[0].Sendername);
      setPortNumber(res[0].Portnumber);
      setPassword(res[0].Password);
      setService(res[0].Service);
      setUserMail(res[0].Usermail);
      setEncryptionMethod(res[0].isSecure);
    }
  };

  function hideLoader() {
    setLoading(false);
  }

  function showLoader() {
    setLoading(true);
  }

  let sendTestMail = async (event) => {
    if (service === "") {
      ErrorMessage("Please enter SMTP Server")
      return;
    }
    if (usermail === "") {
      ErrorMessage("Please enter Email")
      return;
    }
    if (!usermail.includes("@") || !usermail.includes(".com")) {
      ErrorMessage("Please enter Valid Email adress")
      return;
    }
    if (password === "") {
      ErrorMessage("Please enter Password")
      return;
    }
    if (portnumber === "") {
      ErrorMessage("Please enter Portnumber")
      return;
    }
    if (sendername === "") {
      ErrorMessage("Please enter Sender Name")
      return;
    }
    if (tomail === "") {
      ErrorMessage("Please enter To mail")
      return;
    }
    if (!tomail.includes("@") || !tomail.includes(".com")) {
      ErrorMessage("Please enter Valid To Mail adress")
      return;
    }
    event.preventDefault();
    showLoader();
    let data = {
      _id: customerData ? customerData._id : null,
      Service: service,
      Usermail: usermail,
      Password: password,
      Portnumber: portnumber,
      Tomail: tomail,
      Sendername: sendername,
      isSecure: encryptionMethod,
    };
    let returnData = await httpService.getByBoj("testmail", data).then(
      (res) => res.data
    );

    if (returnData === "Email sent successfully") {
      hideLoader();
      SuccessMessage("Email sent successfully")
    } else {
      hideLoader();
      ErrorMessage(returnData)
    }
  };

  let handleOnclick = async (event) => {
    event.preventDefault();
    if (service === "") {
      ErrorMessage("Please enter SMTP Server")
      return;
    }
    if (usermail === "") {
      ErrorMessage("Please enter Usermail")
      return;
    }
    if (!usermail.includes("@") || !usermail.includes(".com")) {
      ErrorMessage("Please enter Valid Email address")
      return;
    }
    if (password === "") {
      ErrorMessage("Please enter Password")
      return;
    }
    if (portnumber === "") {
      ErrorMessage("Please enter Portnumber")
      return;
    }
    if (sendername === "") {
      ErrorMessage("Please enter Sender Name")
      return;
    }

    showLoader();
    let data = {
      _id: customerData ? customerData._id : null,
      Service: service,
      Usermail: usermail,
      Password: password,
      Portnumber: portnumber,
      Sendername: sendername,
      isSecure: encryptionMethod,
      ActionTime: new Date(),
      ActionType: customerData ? "Update" : "Add",
      Module: "SMTP",
      Target: usermail,
    };
    let returnData = await httpService.CreateUpdate(
      "/savesmtpdetails",
      data
    ).then((res) => res.data);
    if (returnData === "SMTP has been created Successfully.") {
      hideLoader();
      SuccessMessage("SMTP has been created successfully")
    } else {
      hideLoader();
      SuccessMessage(returnData)
    }
  };

  const handleCheckChange = (setContent, content) => {
    setContent(!content);
  };

  const changeEncryption = (event) => {
    setEncryptionMethod(event.target.value);
  };
  const resetChangesMade = () => {
    setChangesMade(false); 
  };

  const handleInputChange = () => {
    if (!changesMade) {
      setChangesMade(true); 
    }
  };
  return (
    <>
      <form>
        <SettingNavbar activeTab={activeTab} />
        <div style={{ margin: "15px" }}>
          <div className="pad-15 mt-5" id="smtpTab">
            <div className="form-boxdiv">
              <div className="form-boxtopline5">SMTP</div>
              <div className="form-boxtopcont ">
                {loading ? <Loader /> : null}
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">SMTP Server</label>
                      <input
                        className="form-control"
                        type="text"
                        name="service_smtp"
                        placeholder="Enter SMTP Server"
                        value={service}
                        onChange={(e) => {  handleInputChange()
                          if (e.target.value.match(/\s/)) { // Check if the input contains any space character
                            return; // If it does, return without updating the state
                          }
                          setService(e.target.value); // Update the state with the new value
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">
                        Sender Email Address{" "}
                      </label>
                      <input
                        className="form-control"
                        type="email"
                        name="usermail_smtp"
                        placeholder="Enter Email Address"
                        value={usermail}
                        onKeyDown={(e) => {
                          if (e.key === ' ') {
                            e.preventDefault();
                          }
                        }}
                        onChange={(e) => { handleInputChange();
                          setUserMail(e.target.value);
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">Password</label>
                      <div className="input-group">
                        <input
                          className="form-control"
                          type={showPassword ? "text" : "password"}
                          name="password_smtp"
                          placeholder="Enter Password"
                          value={password}
                          onChange={(e) => { handleInputChange();
                            const newValue = e.target.value.trim(); 
                            setPassword(newValue); 
                          }}
                          required
                        />
                        <div className="input-group-append">
                          <span
                            className="input-group-text"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <BsEyeSlash /> : <BsEye />}
                          </span>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">SMTP Port Number</label>
                      <input
                        className="form-control"
                        type="text"
                        name="port_smtp"
                        placeholder="Enter Port Number"
                        value={portnumber}
                        onChange={(e) => { handleInputChange();
                          if (e.target.value.match(/[^0-9]/)) {
                            return;
                          }
                          setPortNumber(e.target.value);
                        }}
                        required
                        min="1"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">
                        Encryption Method
                      </label>
                      <select
                        className="form-control"
                        value={encryptionMethod}
                        onChange={(event) => {handleInputChange();changeEncryption(event)}
                      }
                      >
                        <option value={"none"}>None</option>
                        <option value={"starttls"}>STARTTLS</option>
                        <option value={"ssltls"}>SSL/TLS</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label className="form-check-label">Sender Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name_smtp"
                        placeholder="Enter Name"
                        value={sendername}
                        onChange={(e) => { handleInputChange();
                          if (e.target.value.match(/[^A-Za-z\s]/gi, "")) {
                            return;
                          }
                          setSenderName(e.target.value);
                        }}
                        required
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div className="test-mailbox custom-checkbox">
                    <input
                      type="checkbox"
                      id="testmail"
                      checked={ticked}
                      className="custom-control-input"
                      onChange={() => handleCheckChange(setTicked, ticked)}
                    />
                    <label
                      className="custom-control-label padt-3 cursor-pointer"
                      style={{ margin: "15px" }}
                      htmlFor="testmail"
                    >
                      Test Mail
                    </label>
                  </div>
                  {ticked === true ? (

                    <div className="row" id="togglefield">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="form-check-label">Enter Email where you want to send test mail</label>
                          <input
                            className="form-control"
                            type="text"
                            name="testmail"
                            placeholder="Enter Email Address"
                            onKeyDown={(e) => {
                              if (e.key === ' ') {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => { handleInputChange();
                              setToMail(e.target.value);
                            }}
                            required
                          />
                        </div>
                      </div>
                    </div>

                  ) : (
                    ""
                  )}
                </div>

                  <button
          className="btn btn-danger marb-15"
          onClick={(e) => {
            e.preventDefault();
            history.goBack();
            resetChangesMade(); // Call resetChangesMade on Cancel button click
          }}
        >
          Cancel
        </button>
        <button
          className="btn btn-success marl-15 marb-15"
          onClick={(event) => {
            handleOnclick(event);
            resetChangesMade(); 
          }}
          disabled={!changesMade}
        >
          Save
        </button>
        {ticked === true ? (
                <button
                  className="btn btn-info marl-15 marb-15"
                  onClick={(event) => {
                    event.preventDefault();
                    sendTestMail(event);
                  }}
                >
                  Test
                </button>
              ) : (
                ""  
              )}
                
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default SmtSettings;
